export default __webpack_public_path__ + "static/media/Summoner's Gloves of Prestige.eb078d19.jpg";